/* Tessuti scroll-reveal — loaded once in <head> with defer. Progressive enhancement. */
(function(){
  var sel = '.t-hero__copy,.t-hero__media,.t-h2,.t-card,.t-pcard,.t-feat__card,.t-edi__card,.t-swatch__item,.t-insta__cell,.t-ctasplit__copy,.t-banner__content,.t-about__body,.t-clients__wrap,.t-trust__item';
  if(!('IntersectionObserver' in window)) return;
  function init(){
    var els = Array.prototype.slice.call(document.querySelectorAll(sel));
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('t-in'); io.unobserve(e.target); } });
    }, { threshold:0, rootMargin:'0px 0px 220px 0px' });
    els.forEach(function(el){
      if(el.dataset.tRev) return; el.dataset.tRev='1';
      el.classList.add('t-reveal');
      var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.transitionDelay = Math.min((sibs%6)*60, 300) + 'ms';
      io.observe(el);
    });
    setTimeout(function(){ els.forEach(function(el){ el.classList.add('t-in'); }); }, 1500);
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* Tessuti cart badge.
 *
 * Fabric is priced per 0.05 of its selling unit, so the quantity Shopify's cart
 * carries is an integer step count, not the metres or kilograms the shopper
 * chose: 1.2 kg reaches the cart as 24. `cart.item_count` sums those counts, so
 * the header badge read 24 — or 6 for a single 0.30 kg line — where the shopper
 * expects to see one item.
 *
 * Count cart lines instead. One fabric in the cart is 1 no matter how much of it
 * was bought, which is also what the badge means on every other store.
 *
 * The badge is rendered server-side only, so before this it also stayed stale
 * after an AJAX add until the next full page load. Refreshing here fixes both.
 */
(function () {
  var SELECTOR = '.th__cart-count';

  function paint(count) {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = String(count);
  }

  function cartUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart.js';
  }

  function refresh() {
    fetch(cartUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart && cart.items && typeof cart.items.length === 'number') paint(cart.items.length);
      })
      .catch(function () {
        /* Leave whatever the server rendered — a stale badge beats a wrong one. */
      });
  }

  function start() {
    if (!document.querySelector(SELECTOR)) return;
    refresh();

    // tessuti:cart-change is dispatched by the product section's sample button;
    // the rest are the cart events Horizon and the Shopify AJAX API emit.
    ['tessuti:cart-change', 'cart:update', 'cart:refresh', 'cartLinesUpdate'].forEach(function (name) {
      document.addEventListener(name, refresh);
    });

    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
